import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const OrderDetailSummary = () => {
  return (
    <div className="col-md-4 col-lg-4 mt-0 mt-lg-0">
      <div className="order-summary-details">
        <div className="order-prices">
          {/* Skeleton for Subtotal */}
          <div className="order-prices-list">
            <p>
              <Skeleton width={80} />
            </p>
            <span>
              <Skeleton width={50} />
            </span>
          </div>
          {/* Skeleton for Tax */}
          <div className="order-prices-list">
            <p>
              <Skeleton width={80} />
            </p>
            <span>
              <Skeleton width={50} />
            </span>
          </div>
          {/* Skeleton for Freight */}
          <div className="order-prices-list">
            <p>
              <Skeleton width={80} />
            </p>
            <span>
              <Skeleton width={30} />
            </span>
          </div>
        </div>

        {/* Skeleton for Total */}
        <div className="order-prices-list order-prices-total">
          <p>
            <Skeleton width={80} />
          </p>
          <span>
            <Skeleton width={50} />
          </span>
        </div>

        {/* Skeleton for Buttons */}
        <div className="subtotal-btn cartpage-btn">
          <Skeleton height={40} width={150} />
          <div className="button-effect popup-checkout-btn">
            <Skeleton height={40} width={150} />
          </div>
        </div>
      </div>
    </div>
  );
};
